



















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { IndexBar, IndexAnchor, Cell, Search } from "vant";
import * as _ from "lodash";
import dataShare from "@/views/mall/dataShare";
import UserService from "@/service/UserService";
import { RoleInfoEntity } from "../../../model/system";
import btripServcice from "@/service/btripServcice";
import { ServiceType } from "../../../model/Base";
import { BtripTextEntity } from "../../../model/Btrip";

@Component({
  name: "chooseTripIntent",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Search.name]: Search,
  },
})
export default class extends Vue {
  keywords = "";

  dataShare = dataShare;

  TripDatas = [];

  get options() {
    return this.dataShare.tripIntents;
  }
  select(value: string) {
    this.dataShare.tripIntent = value;
    this.back();
  }
  //mounted
  mounted() {}

  get filterOptions() {
    let __self = this;
    if (this.keywords != "") {
      let searchList = _.filter(__self.options, (o: any) => o.TextName.indexOf(this.keywords) > -1);
      return _.uniq(searchList);
    }
    return __self.options;
  }
  back() {
    history.back();
  }
}
